/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Program.Summary.vue?vue&type=template&id=4a34e3b4"
import script from "./Program.Summary.vue?vue&type=script&lang=js"
export * from "./Program.Summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports